import React from "react";

const downloadUrl =
  window.location.origin + "/ctzuigrht23tg6h351zgjt/weighbill/";

const WeighBillButton = ({ id, lang }) => {
  const langtext = lang === "hu" ? "HU" : "SLO";
  return (
    <a href={downloadUrl + lang + "/" + id} target="_blank">
      <div className={"btn"}>PDF letöltés {langtext}</div>
    </a>
  );
};

export default WeighBillButton;
